"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RCV_SCHEDULE_ON_BEHALF_GUIDANCE_LINK = void 0;
var RCV_SCHEDULE_ON_BEHALF_GUIDANCE_LINK = 'https://support.ringcentral.com/app/video/desktop-web/setting-delegate-schedule-meeting-on-your-behalf-outlook.html';
exports.RCV_SCHEDULE_ON_BEHALF_GUIDANCE_LINK = RCV_SCHEDULE_ON_BEHALF_GUIDANCE_LINK;
//# sourceMappingURL=constants.js.map
